require('./build/nodejs/global.js');
